import React from 'react';

import classNames from 'classnames';
import { Loading } from 'components/cosmos';
import { ReactComponent as UsersCosmos } from 'components/svg/icons/users-cosmos.svg';
import { TooltipPortal } from 'components/tooltip';
import { translate } from 'components/translate';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import { ContentService } from 'modules/content';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import ContentEvents from '../../events';

const FlagsList = ({
  renderModuleFlags,
  isMobile,
  clearClassTooltipContent,
  isLast,
  item,
  t
}) => {
  const [classesList, setClassesList] = React.useState([]);
  const [isClassesLoaded, setIsClassesLoaded] = React.useState(false);

  const classNameTooltip = classNames('classes--tooltip', {
    'tooltip__portal--bellow': !isLast,
    'tooltip__portal--above': isLast
  });

  const sendEvents = () => {
    ContentEvents.sendModuleEvent({ label: 'ViewGroups' });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.CONTENT.MANAGE_MODULE.MANAGE_MODULE_ICON,
        label: EVENTS_LABELS.CONTENT.MANAGE_MODULE.VIEW_GROUPS,
        action: EVENTS_INTERACTIONS.HOVER
      })
    });
  };

  const onClickOrMouseEnter = () => {
    const fetchClasses = async () => {
      try {
        const response = await ContentService.getModuleClassesInfo(
          item.id,
          item.extra
        );

        setClassesList(response);
        setIsClassesLoaded(true);
      } catch (error) {
        UiService.handleError(error);
      }
    };

    fetchClasses();
  };

  const renderClassList = () => {
    if (!isClassesLoaded) {
      return <Loading center />;
    }

    return (
      <ul>
        {classesList && classesList.length ? (
          classesList.map((classEl) => (
            <li key={classEl.hashId} data-test="class-label">
              {classEl.name}
            </li>
          ))
        ) : (
          <li data-test="warning-message">
            {t('content_list.total_classes_none')}
          </li>
        )}
      </ul>
    );
  };

  return (
    <div className="module-flags-list _mb-5">
      <div className="module-flags-list-half">{renderModuleFlags(item)}</div>
      <button
        className="module-pages-flag module-pages-flag--classes"
        id={`classes-${item.id}`}
        onMouseEnter={onClickOrMouseEnter}
        onClick={onClickOrMouseEnter}
        data-test="class-container"
        aria-label={t('general.classes')}
      >
        <UsersCosmos />
        <TooltipPortal
          arrowPos={isMobile ? 'left' : 'right'}
          parentId={`classes-${item.id}`}
          onShow={sendEvents}
          onHide={clearClassTooltipContent}
          className={classNameTooltip}
        >
          {renderClassList()}
        </TooltipPortal>
      </button>
    </div>
  );
};

FlagsList.propTypes = {
  renderModuleFlags: PropTypes.func,
  getClassTooltipContent: PropTypes.func,
  isMobile: PropTypes.bool,
  clearClassTooltipContent: PropTypes.func,
  item: PropTypes.object,
  isLast: PropTypes.bool,
  t: PropTypes.func
};

export default translate()(FlagsList);
